import React from 'react';
import { useAuth } from '@/contexts/AuthContext';
import { Button } from '@/components/ui/button';
import { LogOut } from 'lucide-react';
import { cn } from '@/lib/utils';
import { useDevice } from '@/hooks/use-device';

interface NavigationProps {
  view: 'daily' | 'weekly' | 'monthly' | 'quick' | 'current' | 'recurring';
  onViewChange: (view: 'daily' | 'weekly' | 'monthly' | 'quick' | 'current' | 'recurring') => void;
}

export function Navigation({ view, onViewChange }: NavigationProps) {
  const { user, signOut } = useAuth();
  const { isMobile } = useDevice();

  const renderUserSection = () => (
    <div className={cn(
      "flex items-center gap-2",
      isMobile && "mt-4"
    )}>
      <Button
        variant="ghost"
        size="icon"
        onClick={() => signOut()}
        className="text-red-600 hover:text-red-700 hover:bg-red-50 h-10 w-10"
        title="Sign out"
      >
        <LogOut className="h-5 w-5" />
      </Button>
    </div>
  );

  // Desktop Navigation
  return (
    <nav className="bg-gray-900 text-white border-b px-6 py-2">
      <div className="max-w-[1800px] mx-auto flex items-center justify-between">
        <div className="flex items-center gap-4">
          <img 
            src="https://i.imgur.com/mkCCqRQ.png" 
            alt="Kohde Logo" 
            className="w-10 h-10 object-contain"
          />
          <div>
            <h1 className="text-2xl font-bold">Kohde</h1>
            <h2 className="text-sm text-gray-300">Room Booking System</h2>
          </div>
        </div>

        <div className="flex items-center">
          {renderUserSection()}
        </div>
      </div>
    </nav>
  );
}